import { Component, OnInit, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { UsersService } from '../../_services/users.service';
import { IuserInformation } from '../../_types/userInterfaces.type';
import { WellsService } from '../../_services/wells.service';
import { SharedFunctionsService } from '../../_services/sharedFunctions.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms'; 
import { UserProfileService } from '../../../_services/user-profile.service';
import { UserProfile } from '../../../_models/user-profile';

@Component({

  selector: 'wells-acl',
  templateUrl: './wellsACL.component.html',
  styleUrls: ['./wellsACL.component.css']

})

export class WellsACLComponent implements OnInit, OnChanges {
  public company: string = "";
  public search: string = "";
  public fields: fields[] = [];
  public batteries: batteries[] = [];
  public wellsOwned: any[] = [];
  public wellsRootAva: any[] = [];
  public wellsRootOwned: any[] = [];
  public wellsAva: any[] = [];
  public wellActiveChangeCount: number = 0;
  public loading: boolean = false;
  public dummbyValue1 = new Date();
  public dummbyValue2 = new Date();
  public up: UserProfile;
  @Input() public user: IuserInformation;
  @Input() public mode: state;
  @Output() hasChangedTrue: EventEmitter<any> = new EventEmitter();
  @Output() hasChangedFalse: EventEmitter<any> = new EventEmitter();
  @Output() public owed: wellsExe[];
  wellACLFrm: UntypedFormGroup;
  public sortArrayObjAva = {
    wellName:false,
    fieldName: true,
    batteryName:true
  }
  public sortArrayObjOwned = {
    wellName: false,
    fieldName: true,
    batteryName: true
  }

  constructor(private UserService: UsersService,
    private fb: UntypedFormBuilder,
    private WellsService: WellsService,
    private SharedFunctions: SharedFunctionsService,
    private ups: UserProfileService) {
    this.wellACLFrm = this.fb.group({
      "field": null,
      "battery":null
    });
    ups.userProfile$.subscribe(result => {
      this.up = result;
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.mode != "undefined") {
      this.mode = <state>changes.mode.currentValue;
    }
    else if (typeof changes.user != "undefined") {
      this.user = <IuserInformation>changes.user.currentValue;
      this.getWells();
    }
  }

  ngOnInit() {
    if (typeof window != 'undefined') {
      this.company = this.up.currentCompany;
      if (typeof this.user != "undefined" && null != this.user) {
        this.getWells();
      }
     
    }
  }

  orderList(columnName: string, list: string) {
    if (list == 'wa') {
      this.SharedFunctions.sortArray(this.wellsAva, columnName, this.sortArrayObjAva);
      if (this.sortArrayObjAva[columnName]) {
        this.sortArrayObjAva[columnName] = false;
      } else {
        this.sortArrayObjAva[columnName] = true;
      }
      this.dummbyValue1 = new Date();
    } else {
      this.SharedFunctions.sortArray(this.wellsOwned, columnName, this.sortArrayObjOwned);
      if (this.sortArrayObjOwned[columnName]) {
        this.sortArrayObjOwned[columnName] = false;
      } else {
        this.sortArrayObjOwned[columnName] = true;
      }
    }
    this.dummbyValue2 = new Date();
  }

  refresh() {
    if (this.loading == false && (this.mode == 0 || this.mode.toString() == "editMode")) { 
      this.wellACLFrm.controls["field"].patchValue(null);
      this.wellACLFrm.controls["battery"].patchValue(null);
      this.batteries = [];
      this.search = "";
      this.getWells();
    }
  }

  getWells() {
    this.loading = true;
    let getwells = this.WellsService.getWellsInCompany(this.company)
      .subscribe(result => {
        this.wellsRootAva = Object.assign([], <wellsExe[]>result);
        this.wellsRootAva.forEach(well => { well.lockIcon = "fas fa-plus" })
        this.sortArrayObjAva.wellName = true;
        this.sortArrayObjOwned.wellName = true;
        this.orderList('wellName', 'wa');
        this.getAvaFields();
        getwells.unsubscribe();
      },
        error => {
          console.log(error);
          this.loading = false;
          getwells.unsubscribe();
        });

  }

  getAvaFields() {
      let getfield = this.UserService.getFieldsInCompany(this.company)
        .subscribe(result => {
          this.fields = <fields[]>result;
          if (this.mode == 1 || this.mode.toString() == "createMode") {
            this.wellsAva = Object.assign([], this.wellsRootAva);
            this.loading = false;
          }
          else {
            this.getOwnedWells();  // 10-7-19
          }
          
          getfield.unsubscribe();
        },
          error => {
            console.log(error);
            this.loading = false;
            getfield.unsubscribe();
          });
  }

  getOwnedWells() {
   let ownedwells =  this.UserService.getUserWellACL(this.user.username, this.company)
      .subscribe(result => {
        this.wellsRootOwned = <any[]>result;
        this.wellsOwned = Object.assign([], this.wellsRootOwned)        
        if (this.wellsOwned.length > 0) {
          this.filterWells();
          this.orderList('wellName', 'wo');
        }
        else {
          this.wellsAva = Object.assign([], this.wellsRootAva);
          this.orderList('wellName', 'wa');
        }

        this.loading = false;
        ownedwells.unsubscribe();
      },
        error => {
          console.log(error);
          this.loading = false;
          ownedwells.unsubscribe();
        });
  }

  getBatteriesInField() {
    let bat = this.WellsService.getBatteriesInField(this.company, this.wellACLFrm.controls['field'].value)
      .subscribe(
        result => {
          this.batteries = <batteries[]>result;
          this.filterWells();
          bat.unsubscribe();
        },
        error => {
          console.log(error);
          this.loading = false;
          bat.unsubscribe();
        })
  }

  getSelectedFieldName(): any {
    let name: string = "";
    this.fields.forEach(field => {
      if (field.fieldID == this.wellACLFrm.controls['field'].value) {
        name =  field.fieldName;
      }
    })
    return name;
  }

  getSelectedBatteryName() {
    let name: any = null;
    this.batteries.forEach(bat => {
      if (bat.batteryID == this.wellACLFrm.controls['battery'].value) {
        name =  bat.batteryName;
      }
    })
    return name;
  }

  fieldChanged() {
    this.wellACLFrm.controls["battery"].patchValue(null);
    this.batteries = [];
    if (null != this.wellACLFrm.controls["field"].value) {
      this.getBatteriesInField();
    }
    else {
      this.filterWells();
      if (this.mode == 0 || this.mode.toString() == "editMode") { 
        this.wellsOwned = Object.assign([], this.wellsRootOwned)
      }
    }
  }

  batteryChanged() {
    this.filterWells();
  }

  initFilterWells() {
    let tempWellArray: any[] = [];
    this.fields.forEach(field => {
      this.wellsRootAva.forEach(well => {
        if (well.fieldName == field.fieldName) {
          well.lockIcon = "fas fa-plus";
          let wellCopy = Object.assign({}, well);
          tempWellArray.push(wellCopy);
        }
      });
    });
    return tempWellArray;
  }

  filterWells() {
    let tempWellArray: any[] = [];
    let tempWellOwnedArray: any[] = [];

    if (null == this.wellACLFrm.controls['battery'].value && null == this.wellACLFrm.controls['field'].value) {
      this.compareWells();
      this.wellsAva = Object.assign([], this.wellsRootAva);
      this.wellsOwned = Object.assign([], this.wellsRootOwned);
    }
    else {
      let fieldName = this.getSelectedFieldName();
      let batteryName = this.getSelectedBatteryName();
      this.wellsRootAva.forEach(well => {
        if (null == this.wellACLFrm.controls['battery'].value && well.fieldName == fieldName) {
          well.lockIcon = "fas fa-plus";
          let wellCopy = Object.assign({}, well);
          tempWellArray.push(wellCopy);
        }
        else if (null != this.wellACLFrm.controls['battery'].value && well.fieldName == fieldName && well.batteryName == batteryName) {
          well.lockIcon = "fas fa-plus";
          let wellCopy = Object.assign({}, well);
          tempWellArray.push(wellCopy);
        }
      });
      this.wellsAva = tempWellArray;
      
      this.wellsRootOwned.forEach(well => {
        if (null == this.wellACLFrm.controls['battery'].value && well.fieldName == fieldName) {
          well.lockIcon = "fas fa-minus"
          let wellCopy = Object.assign({}, well)
          tempWellOwnedArray.push(wellCopy);
        }
        else if (null != this.wellACLFrm.controls['battery'].value && well.fieldName == fieldName && well.batteryName == batteryName) {
          well.lockIcon = "fas fa-minus"
          let wellCopy = Object.assign({}, well)
          tempWellOwnedArray.push(wellCopy);
        }
      })
        this.wellsOwned = tempWellOwnedArray;
      }
  }

  compareWells() {
    this.wellsRootOwned.forEach(owned => {    
      this.wellsRootAva.forEach((ava, index) => {

        owned.lockIcon = "fas fa-minus";
        ava.lockIcon = "fas fa-plus";
        if (ava.wellID == owned.wellID && ava.wellName == owned.wellName) {
          this.wellsRootAva.splice(index, 1);
        }
      })
    })
    this.loading = false;
  }

  getFieldIndex(well: wellsExe, wellList: wellsExe[]): any {
    wellList.forEach((item, index) => {
      if (item.wellID == well.wellID && item.wellName == well.wellName) {
        wellList.splice(index, 1);
        return index;
      }
    })
  }

  changeWellAssoc(well: wellsExe, value: boolean, index: number) {
    let wellAssociation: string = "";
    this.hasChangedTrue.next(true);
    if (this.mode == 0 || this.mode.toString() == "editMode") {
      this.wellActiveChangeCount = this.wellActiveChangeCount + 1;
      if (well.lockIcon != "spinner-border spinner-border-sm") {
        well.lockIcon = "spinner-border spinner-border-sm"
        if (value) { wellAssociation = "add"; }
        let test = this.UserService.userWellAssociation({ "UserIDs": [this.user.companyUserID], "ACLTypeIDs": [well.wellID] }, String(this.company), wellAssociation)
          .subscribe(
            result => {
              if (value) {
                index = this.getFieldIndex(well, this.wellsAva);
                this.getFieldIndex(well, this.wellsRootAva);
                well.lockIcon = "fas fa-minus"
                this.wellsOwned.push(well);
                this.wellsRootOwned.push(well);
              }
              else {
                this.getFieldIndex(well, this.wellsOwned);
                this.getFieldIndex(well, this.wellsRootOwned);
                well.lockIcon = "fas fa-plus"

                this.wellsAva.push(well);
                this.wellsRootAva.push(well)
              }
              if (this.search != "") { 
                let testsave = this.search;
                this.search = "";
                this.search = testsave;
              }
              this.wellActiveChangeCount = this.wellActiveChangeCount - 1;
              if (this.wellActiveChangeCount == 0) {
                this.hasChangedFalse.next(false);
                test.unsubscribe();
              }

            },
            error => {
              console.log(error);
              test.unsubscribe();
              this.wellActiveChangeCount = this.wellActiveChangeCount - 1;
              if (this.wellActiveChangeCount == 0) { this.hasChangedFalse.next(false); }
              if (value) {
                well.lockIcon = "fas fa-plus"
              }
              else {
                well.lockIcon = "fas fa-minus"
              }
            })
      }
    }
    else {
      if (well.lockIcon == "fas fa-plus") {
        this.wellsOwned.push(well)
        this.wellsRootOwned.push(well)
        well.lockIcon = "fas fa-minus"
        this.getFieldIndex(well, this.wellsAva);
        this.getFieldIndex(well, this.wellsRootAva);
      }
      else {
        this.wellsAva.push(well)
        this.wellsRootAva.push(well)

        well.lockIcon = "fas fa-plus"
        this.getFieldIndex(well, this.wellsOwned);
        this.getFieldIndex(well, this.wellsRootOwned);
      }

    }
  }

  returnWellsForCloneUser() {
    return this.wellsOwned;
  }

  transform(value: any[], input: string): any[] {
    if (!value || !input) {
      return value;
    }
    input = input.toLowerCase();
    return value.filter(well => (well.fieldName != null ? well.fieldName.toLowerCase().indexOf(input) > -1 : null) ||
      (well.wellName != null ? well.wellName.toLowerCase().indexOf(input) > -1 : null) ||
      (well.batteryName != null ? well.batteryName.toLowerCase().indexOf(input) > -1 : null) ||
      (well.api != null ? well.api.toLowerCase().indexOf(input) > -1 : null) ||
      (well.serialNumber != null ? well.serialNumber.toLowerCase().indexOf(input) > -1 : null))
  }

  removeAll() {
    this.hasChangedTrue.next(true);
    if (this.search.trim().length == 0 && (null == this.wellACLFrm.controls['battery'].value && null == this.wellACLFrm.controls['field'].value)) {
      this.wellsOwned.forEach((wellOwned) => { wellOwned.lockIcon = "fas fa-plus"; })
      this.wellsAva = this.removeDulicates(Object.assign([], this.wellsAva.concat(this.wellsOwned)));
      this.wellsRootAva = this.removeDulicates(Object.assign([], this.wellsAva.concat(this.wellsOwned)));
      this.wellsOwned = [];
      this.wellsRootOwned = [];

    }
    else if (this.search.trim().length != 0 && (null == this.wellACLFrm.controls['battery'].value && null == this.wellACLFrm.controls['field'].value)) {
      let filteredList = this.transform(this.wellsOwned, this.search);
      filteredList.forEach(fo => { fo.lockIcon = "fas fa-plus"; })
      this.wellsAva = this.removeDulicates(Object.assign([], this.wellsAva.concat(filteredList)));
      this.wellsRootAva = this.removeDulicates(Object.assign([], this.wellsRootAva.concat(filteredList)));
      let flIndex: number = -1;
      let flIndexRoot: number = -1;
      filteredList.forEach(fl => {
        flIndexRoot = this.wellsRootOwned.findIndex(war => war.wellID == fl.wellID)
        flIndex = this.wellsOwned.findIndex(wa => wa.wellID == fl.wellID)
        this.wellsRootOwned.splice(flIndexRoot, 1);
        this.wellsOwned.splice(flIndex, 1);
      })
    }
    else if (this.search.trim().length == 0 && (null != this.wellACLFrm.controls['field'].value || null != this.wellACLFrm.controls['battery'].value)) {
      this.wellsOwned.forEach((wellOwned) => { wellOwned.lockIcon = "fas fa-plus"; })
      this.wellsAva = this.removeDulicates(Object.assign([], this.wellsAva.concat(this.wellsOwned)));
      this.wellsRootAva = this.removeDulicates(Object.assign([], this.wellsRootAva.concat(this.wellsOwned)));
      let waIndex: number = -1;
      this.wellsOwned.forEach(wa => {
        waIndex = this.wellsRootOwned.findIndex(war => war.wellID == wa.wellID);
        this.wellsRootOwned.splice(waIndex, 1);
      })
      this.wellsOwned = [];
    }
    else if (this.search.trim().length != 0 && (null != this.wellACLFrm.controls['field'].value || null != this.wellACLFrm.controls['battery'].value)) {
      let filteredList = this.transform(this.wellsOwned, this.search);
      filteredList.forEach(fo => { fo.lockIcon = "fas fa-plus"; })
      this.wellsAva = this.removeDulicates(Object.assign([], this.wellsAva.concat(filteredList)));
      this.wellsRootAva = this.removeDulicates(Object.assign([], this.wellsRootAva.concat(filteredList)));
      let flIndex: number = -1;
      let flIndexRoot: number = -1;
      filteredList.forEach(fl => {
        flIndexRoot = this.wellsRootOwned.findIndex(war => war.wellID == fl.wellID)
        flIndex = this.wellsOwned.findIndex(wa => wa.wellID == fl.wellID)
        this.wellsRootOwned.splice(flIndexRoot, 1);
        this.wellsOwned.splice(flIndex, 1);
      })
    }
  }

  addAll() {
    this.hasChangedTrue.next(true);
    if (this.search.trim().length == 0 && (null == this.wellACLFrm.controls['battery'].value && null == this.wellACLFrm.controls['field'].value)) {
      this.wellsAva.forEach((wellAva) => { wellAva.lockIcon = "fas fa-minus"; })
      this.wellsOwned = this.removeDulicates(Object.assign([], this.wellsOwned.concat(this.wellsAva)));
      this.wellsRootOwned = this.removeDulicates(Object.assign([], this.wellsOwned.concat(this.wellsAva)));
      this.wellsAva = [];
      this.wellsRootAva = [];
    }
    else if (this.search.trim().length != 0 && (null == this.wellACLFrm.controls['battery'].value && null == this.wellACLFrm.controls['field'].value)) {
      let filteredList = this.transform(this.wellsAva, this.search);

      filteredList.forEach(fa => { fa.lockIcon = "fas fa-minus"; })
      this.wellsOwned = this.removeDulicates(Object.assign([], this.wellsOwned.concat(filteredList)));
      this.wellsRootOwned = this.removeDulicates(Object.assign([], this.wellsRootOwned.concat(filteredList)));
      let flIndex: number = -1;
      let flIndexRoot: number = -1
      filteredList.forEach(fl => {
        flIndexRoot = this.wellsRootAva.findIndex(war => war.wellID == fl.wellID)
        flIndex = this.wellsAva.findIndex(wa => wa.wellID == fl.wellID)
        this.wellsRootAva.splice(flIndexRoot, 1);
        this.wellsAva.splice(flIndex, 1);
      })
    }
    else if (this.search.trim().length == 0 && (null != this.wellACLFrm.controls['field'].value || null != this.wellACLFrm.controls['battery'].value)) {
      this.wellsAva.forEach((wellAva) => { wellAva.lockIcon = "fas fa-minus"; })
      this.wellsOwned = this.removeDulicates(Object.assign([], this.wellsOwned.concat(this.wellsAva)));
      this.wellsRootOwned = this.removeDulicates(Object.assign([], this.wellsRootOwned.concat(this.wellsAva)));
      let waIndex: number = -1;
      this.wellsAva.forEach(wa => {
        waIndex = this.wellsRootAva.findIndex(war => war.wellID == wa.wellID);
        this.wellsRootAva.splice(waIndex,1);
      })
      this.wellsAva = [];
    }
    else if (this.search.trim().length != 0 && (null != this.wellACLFrm.controls['field'].value || null != this.wellACLFrm.controls['battery'].value)) {
      let filteredList = this.transform(this.wellsAva, this.search);
      filteredList.forEach(fa => { fa.lockIcon = "fas fa-minus"; })
      this.wellsOwned = this.removeDulicates(Object.assign([], this.wellsOwned.concat(filteredList)));
      this.wellsRootOwned = this.removeDulicates(Object.assign([], this.wellsRootOwned.concat(filteredList)));
      let flIndex: number = -1;
      let flIndexRoot:number = -1
      filteredList.forEach(fl => {
        flIndexRoot = this.wellsRootAva.findIndex(war => war.wellID == fl.wellID)
        flIndex = this.wellsAva.findIndex(wa => wa.wellID == fl.wellID)
        this.wellsRootAva.splice(flIndexRoot, 1);
        this.wellsAva.splice(flIndex, 1);
      })
    }
  }

  removeDulicates(list: Array<any>) {
    let a = [];
   list.map(x => {
      if (!a.includes(x)) {
        a.push(x)
      }
    })
    return a;
  }

}

interface fields {
  fieldID: number;
  fieldName: string;
}

interface batteries {
  batteryID: number;
  batteryName: string;
}

interface wells {
  wellID: number;
  wellName: string;
  batteryName: string;
  fieldName: string;
  api: string;
  serialNumber: string;
}

interface wellsExe extends wells{
  lockIcon: string;
}

export enum state {
  cloneMode = 2,
  createMode = 1,
  editMode = 0
}
